import React from 'react';
import createStore from './store';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';

import '@mantine/core/styles.css';
import '@mantine/charts/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/dropzone/styles.css';
import 'mantine-datatable/styles.layer.css';
import '@mantine/notifications/styles.css';
import 'dayjs/locale/ja';
import { mantineTheme } from './theme';
import { Notifications } from '@mantine/notifications';
import RootContainer from './containers/RootContainer';

const store = createStore()

const App = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <MantineProvider theme={mantineTheme}>
          <DatesProvider settings={{ locale: 'ja' }}>
            <Notifications position="bottom-center" zIndex={1100} />
            <Routes>
              <Route path="/admin/*" element={<RootContainer />} />
            </Routes>
          </DatesProvider>
        </MantineProvider>
      </BrowserRouter>
    </Provider>
  )
}

export default App
